import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, first } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../../shared/components/az-spinner/spinner.component';

@Component({
    selector: 'app-login',
    imports: [CommonModule, SpinnerComponent],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent implements OnDestroy, OnInit {
  private unsubscribe: Subscription[] = [];
  private returnUrl: string = '/home';

  constructor(
    private authService: AuthService, 
    private router: Router,
    private route: ActivatedRoute
  ) {
    // Get return URL from query params or default to home
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
  }

  ngOnInit(): void {
    // Check if already logged in before initiating SSO
    const existingAuth = this.authService.getAuthFromLocalStorage();
    if (existingAuth) {
      console.log('User already has stored auth, redirecting...');
      this.router.navigate([this.returnUrl]);
      return;
    }
    
    // Start SSO login flow
    this.login('AzureAD');
  }

  login(provider: string) {
    console.log(`Login with ${provider} fron login component`);
    const loginSubscr = this.authService
      .loginSSO(provider)
      .pipe(first())
      .subscribe();
    this.unsubscribe.push(loginSubscr);
  }

  ngOnDestroy(): void {
    this.unsubscribe.forEach((obs) => obs.unsubscribe());
  }
}
